import setupPdf from './setup-pdf';

const { renderPdf, printPdf, loadPdfJsLib, getDocument, loadRenderedPdf } = setupPdf();
export { renderPdf, printPdf, loadPdfJsLib, getDocument, loadRenderedPdf };
